import React, {
  useEffect,
} from "react";

import { useHistory } from "react-router-dom";

import { useSetRecoilState } from "recoil";

import KritikSaranForm from "../../components/kritik/KritikSaranForm";

import { titleState } from "../../storage/pages";

const KritikSaranCreate = () => {
  /*
  |--------------------------------------------------------------------------
  | TITLE
  |--------------------------------------------------------------------------
  */

  const setTitle =
    useSetRecoilState(titleState);

  useEffect(() => {
    setTitle(
      "Buat Kritik & Saran"
    );
  }, [setTitle]);

  /*
  |--------------------------------------------------------------------------
  | NAVIGATE
  |--------------------------------------------------------------------------
  */

    const history = useHistory();

  /*
  |--------------------------------------------------------------------------
  | SUCCESS
  |--------------------------------------------------------------------------
  */

    const handleSuccess = () => {
    history.push("/kritik-saran-saya");
    };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-md-10">
          {/* HEADER */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <div className="fw-bold fs-5 mb-1">
                Form Kritik & Saran
              </div>

              <div className="text-muted">
                Silahkan isi form berikut
                untuk mengirim kritik
                atau saran.
              </div>
            </div>
          </div>

          {/* FORM */}
          <KritikSaranForm
            onSuccess={
              handleSuccess
            }
          />
        </div>
      </div>
    </>
  );
};

export default KritikSaranCreate;